import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BanknoteIcon, UsersIcon, MessageCircleOffIcon } from 'lucide-react';
const problems = [{
  icon: BanknoteIcon,
  title: 'El dinero es motivo de guerra',
  description: <>
        Cada conversación sobre plata <strong data-id="element-246">termina en pelea</strong>. El
        estrés financiero se convirtió en el <em data-id="element-247">tercer integrante</em> de la
        relación.
      </>
}, {
  icon: UsersIcon,
  title: 'Socios, no amantes',
  description: <>
        Se sienten más como <strong data-id="element-248">compañeros de cuarto</strong> que como
        pareja. La logística diaria <em data-id="element-249">reemplazó a la intimidad</em>.
      </>
}, {
  icon: MessageCircleOffIcon,
  title: 'Silencio ensordecedor',
  description: <>
        Hablan de cuentas, horarios y problemas, pero hace meses que{' '}
        <strong data-id="element-250">no tienen una conversación real</strong> y profunda.
      </>
}];
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#0D002B]" data-id="element-251">
      <div className="max-w-6xl mx-auto px-6" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-20" data-id="element-253">
          <div className="inline-block bg-[#7C3AED]/20 text-[#C4B5FD] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-254">
            EL PROBLEMA REAL
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-serif" data-id="element-255">
            Cuando el mundo exterior <br className="hidden md:block" data-id="element-256" />
            <span className="text-[#E5A83B] italic" data-id="element-257">se mete en la cama</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-16" data-id="element-258">
          {problems.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.6,
            delay: index * 0.15,
            ease: 'easeOut'
          }} className="bg-[#E0D7FF] rounded-[20px] border border-white p-8 md:p-10 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)] flex flex-col items-center text-center" data-id="element-259">
                <div className="w-16 h-16 bg-[#7C3AED]/20 rounded-full flex items-center justify-center mb-8" data-id="element-260">
                  <Icon className="w-8 h-8 text-[#7C3AED]" strokeWidth={2} data-id="element-261" />
                </div>
                <h3 className="text-xl font-bold text-[#1E0A3C] mb-4 font-serif leading-snug" data-id="element-262">
                  {item.title}
                </h3>
                <p className="text-[#3B1F6E] leading-relaxed font-sans font-medium text-lg" data-id="element-263">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="text-center" data-id="element-264">
          <p className="text-[#C4B5FD] font-medium text-lg" data-id="element-265">
            👉 <em data-id="element-266">Pero hay una forma de revertir esto...</em>
          </p>
        </div>
      </div>
    </section>;
}